module.exports = __webpack_public_path__ + "static/img/call_center.66ce664.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/call_center.svg
// module id = c3ay
// module chunks = 1